const {
  location: { origin },
} = window;

export const redirectPath = '/auth';
export const redirectUri = `${origin}${redirectPath}`;
export const silentRedirectPath = '/auth-silent';
export const silentRedirectUri = `${origin}${silentRedirectPath}`;
